<script setup lang="ts">
import { inject } from 'vue'

const { handleClosePicker } = inject('closePicker')
</script>

<template>
  <BaseButton type="button" @click="handleClosePicker()">
    <AppIcon class="p-2" icon="times" type="far" />
  </BaseButton>
</template>
